module.exports = __webpack_public_path__ + "static/img/13.ab8fa20.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/17/eng/13.png
// module id = 9r4x
// module chunks = 0